import React from 'react';

import { IVideoBlockFullwidthFields } from '../../../types/contentful';

import { Layout, Column } from '../Layout';
import { VimeoVideo } from './VimeoVideo';

import { VideoBlockContainer } from './styles';

interface Props extends IVideoBlockFullwidthFields {
  sysId?: string;
}

export function VideoBlockFullWidth(data: Props) {
  const { sysId, hidden } = data;

  return (
    <VideoBlockContainer
      hidden={!!hidden}
      data-blockid="videoBlockFullwidth"
      data-testid="videoBlockFullwidth"
      data-elementid={sysId}
      marginTop={{ 0: 'blockMarginY', tablet: 'blockMarginY_tablet' }}
      marginBottom={{ 0: 'blockMarginY', tablet: 'blockMarginY_tablet' }}
    >
      <Layout>
        <Column size={{ 0: 12 }}>
          <VimeoVideo {...data} />
        </Column>
      </Layout>
    </VideoBlockContainer>
  );
}
